import { fromJS } from 'immutable';
import { replace } from 'connected-react-router';
import { message } from 'antd';

// Constants
import { CONSTANTS } from './constants';
import { api, METHOD, REQUEST_URL, ROUTE_NAMES, formatPattern } from '../../utils';
import { strings } from '../../localization';

import { getUserData, getKeycloakUserData } from './selectors';

export const onChangePasswordError = (hasError, errorText) => ({
    type: CONSTANTS.ON_AUTH_CHANGE_PASSWORD_ERROR,
    payload: { hasError, errorText }
});

export const onChangePasswordModalIsLoading = isLoading => ({
    type: CONSTANTS.ON_AUTH_CHANGE_PASSWORD_IS_LOADING,
    payload: { isLoading }
});

export const onChangePasswordModalIsShown = isShown => ({
    type: CONSTANTS.ON_AUTH_CHANGE_PASSWORD_IS_SHOWN,
    payload: { isShown }
});

export const onAuthIsLoading = isLoading => ({
    type: CONSTANTS.ON_AUTH_IS_LOADING,
    payload: { isLoading }
});

export const onAuthIsAuthorized = isAuthorized => ({
    type: CONSTANTS.ON_AUTH_IS_AUTHORIZED,
    payload: { isAuthorized }
});

const onAuthToken = token => ({
    type: CONSTANTS.ON_AUTH_TOKEN,
    payload: { token }
});

const onAuthUser = (keycloakUserData, userData) => ({
    type: CONSTANTS.ON_AUTH_USER,
    payload: { userData, keycloakUserData }
});

export const removeUserData = () => ({
    type: CONSTANTS.ON_AUTH_USER,
    payload: {
        userData: null
    }
});

const onAuthLogout = () => ({
    type: CONSTANTS.ON_AUTH_LOGOUT,
    payload: {}
});

export const onEditModalIsShown = isShown => ({
    type: CONSTANTS.ON_AUTH_EDIT_MODAL_IS_SHOWN,
    payload: { isShown }
});

const onEditModalIsLoading = isLoading => ({
    type: CONSTANTS.ON_AUTH_EDIT_MODAL_IS_LOADING,
    payload: { isLoading }
});

export const setUserProfile = profile => (dispatch, getState) => {
    const authState = getState().auth;
    if (authState.get('isLoading') || !profile) {
        throw new Error('No profile or already loading');
    }
    dispatch(onAuthIsLoading(true));

    return api(REQUEST_URL.USER, METHOD.PUT, {})
        .then(res => {
            if (res && res.ok) {
                dispatch(onAuthUser(fromJS(profile), fromJS(res.body)));
                dispatch(onAuthIsLoading(false));
            }
        })
        .catch(() => {
            dispatch(onAuthIsLoading(false));
        });
};

export const onEditUser = (userId, values) => (dispatch, getState) => {
    dispatch(onEditModalIsLoading(true));
    const existingUserData = getUserData(getState());
    const updatedUserData = {
        ...existingUserData.toJS(),
        ...values
    };
    return api(
        formatPattern(REQUEST_URL.USER_ID, {
            userId
        }),
        METHOD.PATCH,
        updatedUserData
    )
        .then(res => {
            if (res && res.ok) {
                const existingKeycloakUserData = getKeycloakUserData(getState());
                dispatch(onEditModalIsLoading(false));
                dispatch(onEditModalIsShown(false));
                dispatch(onAuthUser(existingKeycloakUserData, fromJS(updatedUserData)));
            }
        })
        .catch(err => {
            dispatch(onEditModalIsLoading(false));
            dispatch(onEditModalIsShown(false));
            throw err;
        });
};

export const onChangePassword = (userId, newPassword) => dispatch => {
    dispatch(onChangePasswordModalIsLoading(true));
    return api(
        `${formatPattern(REQUEST_URL.USER_CHANGE_PASSWORD, {
            userId
        })}?password=${newPassword}`,
        METHOD.PATCH
    )
        .then(res => {
            // console.log(res.body);
            if (res && res.ok) {
                dispatch(onChangePasswordModalIsShown(false));
                dispatch(onChangePasswordModalIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onChangePasswordModalIsShown(false));
            dispatch(onChangePasswordModalIsLoading(false));
            throw err;
        });
};

export const handleLoginSubmit = formValues => (dispatch, getState) => {
    if (getState().auth.get('isLoading') || !formValues) return;
    dispatch(onAuthIsLoading(true));

    return api(REQUEST_URL.AUTH_LOGIN, METHOD.POST, {
        loginToken: btoa(`${formValues.name}:${formValues.password}`)
    })
        .then(res => {
            if (res && res.ok) {
                const { token, ...user } = res.body;

                if (typeof Storage !== 'undefined') {
                    localStorage.setItem('wattAnalytics:authToken', token);
                }
                dispatch(onAuthUser(fromJS(user)));
                dispatch(onAuthToken(token));
                dispatch(onAuthIsLoading(false));
                dispatch(onAuthIsAuthorized(true));
            }
        })
        .catch(err => {
            dispatch(onAuthIsLoading(false));
            console.log('err', err);
        });
};

export const handleApiError = err => dispatch => {
    if (!err) {
        message.error(strings.msgErrorApi);
    } else {
        dispatch(replace(ROUTE_NAMES.LOGIN));
        dispatch(onAuthLogout());
    }
};
